module.exports = __webpack_public_path__ + "img/navigate_before_white_32px@2x.ad24dcf8.png";